import { Fragment, type FunctionComponent, useEffect } from 'react'

import { openNewAzurePlanDrawer } from 'src/actions/drawerActions'
import { stopLoading } from 'src/actions/loadingActions'
import { openNoAzureModal } from 'src/actions/modalActions'

import Button from 'src/components/Common/Button'
import Section from 'src/components/Common/Section'
import Spacer from 'src/components/Common/Spacer'
import NoAzureModal from 'src/components/Modals/NoAzureModal'

import { type RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'

import azureviews from '../../images/dummies/azureviews.png'

const NoAzureSplashScreen: FunctionComponent = (): JSX.Element => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const open = useSelector((state: RootStateOrAny) => state.modals.noazuremodal)

  const handleClick = () => {
    navigate('/tickets/')
    dispatch(openNewAzurePlanDrawer())
  }

  useEffect(() => {
    dispatch(stopLoading())
    if (!open) {
      dispatch(openNoAzureModal())
    }
  }, [dispatch, open, location.pathname])

  return (
    <Fragment>
      <Section>
        <img alt="What you could have" src={azureviews} />

        <NoAzureModal title="Ooops..." open={open} loading={false}>
          You don't seem to have any Azure services with us, are you interested?
          <Spacer />
          <div className="flex justify-center">
            <Button className="" variant="primary" onClick={() => handleClick()}>
              Click here!
            </Button>
          </div>
        </NoAzureModal>
      </Section>
    </Fragment>
  )
}

export default NoAzureSplashScreen
